export const INITIAL_STATE = {
  page: 1,
  possiblePage: 1,
  pagesCount: 0,
  isFetching: false,
  totalCount: 0
};

export default ({ fetchType, fetchSuccessType, fetchErrorType, possiblePageUpdateType }) => {

  return (state = INITIAL_STATE, action) => {
    switch(action.type) {
      case fetchType: {
        const newPage = action.page || state.page;

        return {
          ...state,
          page: newPage,
          possiblePage: newPage,
          isFetching: true
        };
      }

      case fetchSuccessType: {
        return {
          ...state,
          pagesCount: Math.ceil(action.result.meta.count / action.result.meta.limit),
          totalCount: action.result.meta.count,
          isFetching: false
        };
      }

      case fetchErrorType: {
        return {
          ...state,
          isFetching: false
        };
      }

      case possiblePageUpdateType: {
        return {
          ...state,
          possiblePage: action.possiblePage
        };
      }

      default: {
        return state;
      }
    }
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/pagingMaker.js
 **/